module.exports = __webpack_public_path__ + "static-portal/img/009.cb1375c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/009.jpg
// module id = grO6
// module chunks = 4